import { Box, SxProps, Typography } from '@mui/material';

const messageBubbleStyle: SxProps = {
  backgroundColor: 'primary.main',
  padding: 2,
  margin: '10px 0',
  maxWidth: '80%',
  wordWrap: 'break-word',
  color: 'white',
  borderRadius: '20px 20px 0px 20px'
};

type Props = {
  text: string;
};

export const MessageBubble: React.FC<Props> = ({ text }) => {
  return (
    <Box sx={messageBubbleStyle}>
      <Typography variant="body2" whiteSpace="pre-line">
        {text}
      </Typography>
    </Box>
  );
};
